export default __webpack_public_path__ + "static/B0064-7d1e6d5988074d4fd48753126e3bcd7f.png";